// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"3376e735","429":"864ed906","818":"864ed906"}[chunkId] + ".chunk.css";
};